import React from 'react';
import { useDispatch } from 'react-redux';
import { useShallowEqualSelector, useTranslate, useCurrentUser } from '@hooks';
import { updatePassword, updateUserPassword } from '@actions';
import { FormGroup, Label } from 'reactstrap';
import { Form, FormAction, Button, PasswordInput } from '@dotone/react-ui-core';

const UserFormPassword = (props) => {
  const { t } = useTranslate('password', 'edit');
  const { tShared } = useTranslate('validation');
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUser();

  const { isLoading } = useShallowEqualSelector(({ passwordUpdate }) => passwordUpdate);
  const { isLoading: submitting } = useShallowEqualSelector(
    ({ userPasswordUpdate }) => userPasswordUpdate
  );

  const { network } = currentUser;

  const onSubmit = (values) => {
    if (network) {
      dispatch(updateUserPassword(values));
    } else {
      dispatch(updatePassword(values));
    }
  };

  return (
    <Form onSubmit={onSubmit} {...props}>
      <FormGroup>
        <Label for="currentPassword">{t('currentPassword')}</Label>
        <PasswordInput
          name="currentPassword"
          inputProps={{
            type: 'password',
            placeholder: t('currentPassword'),
            rules: {
              required: true,
            },
          }}
        />
      </FormGroup>
      <FormGroup>
        <Label for="currentPassword">{t('newPassword')}</Label>
        <PasswordInput
          name="password"
          inputProps={{
            type: 'password',
            placeholder: t('newPassword'),
            rules: {
              required: true,
            },
          }}
        />
      </FormGroup>
      <FormGroup>
        <Label for="currentPassword">{t('passwordConfirmation')}</Label>
        <PasswordInput
          name="passwordConfirmation"
          inputProps={{
            type: 'password',
            placeholder: t('passwordConfirmation'),
            rules: {
              required: true,
              match: {
                field: 'password',
                message: tShared('passwordMatch'),
              },
            },
          }}
        />
      </FormGroup>
      <FormAction className="mb-3">
        <Button block color="primary" type="submit" submitting={isLoading || submitting}>
          {t('submit')}
        </Button>
      </FormAction>
    </Form>
  );
};

export default UserFormPassword;
